import { select, call } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { userProfile } from 'redux/saga/entities/bound';
import { isLoggedIn } from 'redux/saga/selectors';
import requireMembershipSaga from 'routes/helpers/requireMembershipStatus';
import { memberStatus } from 'enums/memberStatus';

// redirects to the signup URL for this item if you are not logged in
// or redirects to / if you already have a subscription
export function* purchaseOnEnterSaga(client, nextState, replaceState) {
  const loggedIn = yield select(isLoggedIn);
  const isPurchaseLanding = /\/purchase\/pending($|\/)/.test(nextState.location.pathname);

  if (isPurchaseLanding) {
    // If the user goes to the purchase landing page, we are not going to redirect them or load any additional data.
    return;
  }

  if (!loggedIn) {
    return yield call(replaceState, {
      ...nextState.location,
      pathname: nextState.location.pathname.replace(/^\/purchase/, '/signup'),
    });
  }

  yield call(fetchEntityIfNeeded, userProfile, [client]);

  yield call(requireMembershipSaga, client, replaceState, [memberStatus('UNSUBSCRIBED')]);
}
